import { useFetch } from 'hooks/use-fetch/use-fetch';
import useQueryLocation from 'hooks/use-query';
import { useQuery } from 'react-query';
import { fleetRequestConfig } from 'request-config/fleet/fleet.request-config';
import { ReactQueryKeys } from 'common/enums';
import { FilesByIdQueryData } from './use-files-by-id.props';

export const useFilesByIdQuery = (vehicleIdProps?: string) => {
  const queryLocation = useQueryLocation();
  const vehicleId = vehicleIdProps || queryLocation.id;

  const { fetch } = useFetch<FilesByIdQueryData>({
    loadingKey: `filesByIdQuery${vehicleId}`,
    isShowLoading: false,
    ...fleetRequestConfig.filesById(vehicleId as string)
  });

  const { data, ...restQueryProps } = useQuery([...CASH_KEY_FILES_BY_ID_QUERY, vehicleId], () => fetch(), {
    enabled: !!vehicleId
  });

  return { filesByIdQuery: data?.data || [], ...restQueryProps };
};

export const CASH_KEY_FILES_BY_ID_QUERY = [ReactQueryKeys.FleetFilesById];
